import { defineStore } from "pinia";
import { state, useFlexiable, FitType } from "@jtzbb/flexiable-vue";
import { computed } from "vue";
import { isMobileDevice } from "@/components/basic/share/utils";

export const useFlexStore = defineStore("flexStore", () => {
  function initFlexiable() {
    if (isMobileDevice()) {
      useFlexiable({
        forceRot: false,
        designWidth: 750,
        designHeight: 1334,
        forceHorizon: false,
        fullScreen: true,
        minRatio: 750 / 1334,
        fitType: FitType.width,
      });
      return;
    }
    useFlexiable({
      forceRot: false,
      designWidth: 1920,
      designHeight: 940,
      forceHorizon: false,
      fullScreen: true,
      minRatio: 1920 / 940,
      fitType: FitType.height,
    });
  }

  const rem = computed(() => state.layout.rem);

  return { initFlexiable, rem };
});
